import { Action } from '@reduxjs/toolkit';

import { Response } from 'src/actions/request/types';

export interface FluxStandardAction<Type extends string, Payload = undefined>
  extends Action<Type> {
  payload?: Payload;
  error?: any;
  meta?: any;
}

export const createTypedAction = <
  T extends string,
  P = undefined,
  E = undefined,
  M = undefined
>(
  type: T,
  // assert `undefined` to `any` here to force types for otherwise optional arguments
  // e.g. createTypedAction('type', 'payload') has a payload type `string` and not `string | undefined`
  payload: P = undefined as any,
  error: E = undefined as any,
  meta: M = undefined as any
) => ({
  type,
  payload,
  error,
  meta,
});

type TypedAction = ReturnType<typeof createTypedAction>;
type ResponseAction = Response<any, any, any>;

type ActionCreatorReturningMap = {
  [key: string]:
    | ((...arg: any[]) => ReturnType<typeof createTypedAction>)
    | ((...arg: any[]) => Promise<ResponseAction>);
};

export type ActionCreatorMap<Map extends ActionCreatorReturningMap> = {
  [K in keyof Map]: ReturnType<Map[K]> extends TypedAction
    ? ReturnType<Map[K]>
    : ReturnType<Map[K]> extends Promise<infer Response>
    ? Response
    : never;
};

export type ActionCreatorAction<Map extends ActionCreatorReturningMap> =
  ActionCreatorMap<Map>[keyof Map];
